import React, { useState, useEffect } from 'react';
import { NavLink, useHistory, useLocation } from 'react-router-dom';
import {
  MdDashboard,
  MdPsychology,
  MdTranslate,
  MdLogout,
  MdChevronLeft,
  MdChevronRight,
  MdBookmark,
  MdArticle,
  MdAddBox,
} from 'react-icons/md';
import './Sidebar.css';

const BOOKMARK_KEY = 'emonews-bookmarks';
const getBookmarkCount = () => {
  try { return JSON.parse(localStorage.getItem(BOOKMARK_KEY) || '[]').length; }
  catch { return 0; }
};

const Sidebar = ({ collapsed, onToggle, className }) => {
  const history = useHistory();
  const location = useLocation();
  const isTamil = location.pathname === '/scanner-tamil';
  const [bookmarkCount, setBookmarkCount] = useState(() => getBookmarkCount());

  // Live bookmark badge update
  useEffect(() => {
    const update = () => setBookmarkCount(getBookmarkCount());
    window.addEventListener('storage', update);
    return () => window.removeEventListener('storage', update);
  }, []);

  const NAV_ITEMS = [
    {
      to: '/overview',
      icon: <MdDashboard />,
      label: isTamil ? 'முகப்பு' : 'Dashboard',
    },
    {
      to: '/scanner',
      icon: <MdPsychology />,
      label: isTamil ? 'ஆங்கிலம்' : 'English',
    },
    {
      to: '/scanner-tamil',
      icon: <MdTranslate />,
      label: 'தமிழ்',
    },
    {
      to: '/articles',
      icon: <MdArticle />,
      label: isTamil ? 'கட்டுரைகள்' : 'Articles',
    },
    {
      to: '/bookmarks',
      icon: <MdBookmark />,
      label: isTamil ? 'சேமிப்பு' : 'Bookmarks',
      badge: bookmarkCount > 0 ? bookmarkCount : null,
    },
  ];

  const handleLogout = () => {
    localStorage.removeItem('isAuthenticated');
    history.push('/');
  };

  return (
    <aside
      className={`sidebar ${collapsed ? 'sidebar--collapsed' : ''} ${className || ''}`}
      role="navigation"
      aria-label="Main navigation"
    >
      {/* Brand */}
      <div className="sidebar__brand">
        <div className="sidebar__brand-icon" aria-hidden="true">
          <img src="/emonews-logo.png" alt="EmoNews" className="sidebar-logo-img" style={{ width: '100%', height: '100%', borderRadius: 'inherit', objectFit: 'cover' }} />
        </div>
        {!collapsed && (
          <div className="sidebar__brand-text">
            <span className="sidebar__brand-name">EmoNews</span>
            <span className="sidebar__brand-tag">AI-Powered</span>
          </div>
        )}
        <button
          className="sidebar__collapse-btn"
          onClick={onToggle}
          aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        >
          {collapsed ? <MdChevronRight /> : <MdChevronLeft />}
        </button>
      </div>

      {/* Nav */}
      <nav className="sidebar__nav" role="list">
        {NAV_ITEMS.map(item => (
          <NavLink
            key={item.to}
            to={item.to}
            className="sidebar__link"
            activeClassName="sidebar__link--active"
            title={collapsed ? item.label : ''}
            role="listitem"
          >
            <span className="sidebar__link-icon" aria-hidden="true">{item.icon}</span>
            {!collapsed && <span className="sidebar__link-label">{item.label}</span>}
            {item.badge && (
              <span className="sidebar__badge" aria-label={`${item.badge} bookmarks`}>
                {item.badge > 99 ? '99+' : item.badge}
              </span>
            )}
          </NavLink>
        ))}
      </nav>

      {/* Footer */}
      <div className="sidebar__footer">
        <button
          className="sidebar__logout"
          onClick={handleLogout}
          title={collapsed ? (isTamil ? 'வெளியேறு' : 'Logout') : ''}
          aria-label={isTamil ? 'வெளியேறு' : 'Logout'}
        >
          <span className="sidebar__link-icon" aria-hidden="true"><MdLogout /></span>
          {!collapsed && <span>{isTamil ? 'வெளியேறு' : 'Logout'}</span>}
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
